import pDebounce from 'p-debounce';
import { useAsyncAbortable } from 'react-async-hook';
import { EMPTY_ARRAY } from '../../../shared/constants';
import { api } from './instance';

async function searchDoctor(abortSignal, query) {
  query = query.trim();
  if (query) {
    const data = await api.auth
      .post('onlinebooking/practitioner-search', {
        signal: abortSignal,
        json: {
          searchTerm: query.trim(),
          role: 'GeneralPractitioner',
        },
      })
      .json();
    if (Array.isArray(data)) {
      return data;
    }
  }
  return EMPTY_ARRAY;
}

const debouncedSearchAddress = pDebounce(searchDoctor, 1000);

export function useDoctorSearch(query) {
  return useAsyncAbortable(debouncedSearchAddress, [query]);
}
